import React, { useState } from 'react';
import PhotoshootCard from './PhotoshootCard';
import Pagination from './Pagination';

const PhotoshootGallery = ({ photoshoots }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const shootsPerPage = 12;

    const indexOfLastShoot = currentPage * shootsPerPage;
    const indexOfFirstShoot = indexOfLastShoot - shootsPerPage;
    const currentShoots = photoshoots.slice(indexOfFirstShoot, indexOfLastShoot);
    const totalPages = Math.ceil(photoshoots.length / shootsPerPage);

    return (
        <div className="py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {currentShoots.map((photoshoot) => (
                        <PhotoshootCard
                            key={photoshoot.id}
                            photoshoot={photoshoot}
                        />
                    ))}
                </div>

                {photoshoots.length === 0 && (
                    <div className="text-center py-20">
                        <p className="text-gray-500 text-lg">No photoshoots available yet.</p>
                    </div>
                )}

                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                    />
                )}
            </div>
        </div>
    );
};

export default PhotoshootGallery;